<template>
<div class="common-layout">
  <el-container>
    <Header />

    <el-main>
      <slot></slot>
    </el-main>    
    <el-footer class="footer">
      &copy; Posti
    </el-footer>    

    <TaskModalCreate />

  </el-container>
</div>
</template>

<script>
import { ElMain } from 'element-plus';
import Header from '@/components/Header';
import TaskModalCreate from '@/components/TaskModalCreate';

export default {
  props: {
  },
  name: 'AuthenticatedLayout',
  components: {    
    Header,
    ElMain,
    TaskModalCreate
  },    
  created(){
    this.$store.dispatch('taskData/fetchTaskCategories');
    this.$store.dispatch('taskData/fetchActiveUsers');
    this.$store.dispatch('taskData/fetchActiveClients');
  }
};
</script>
<style scoped>
/* Estilo global do layout */
.common-layout {
  height: 100vh;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.logo img {
  height: 40px;
}

.menu {
  flex: 1;
  margin-left: 20px;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notification {
  cursor: pointer;
}

.username {
  margin: 0 10px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.main-content {
  padding: 20px;
  background-color: #FFFFFF;
}

.footer {
  text-align: center;
  background-color: #F3F4F6;
  padding: 10px 20px;
  font-size: 14px;
  color: #4C6B89;  
  bottom: 0;  
  width: 100%;
}
@media screen and (max-width: 768px) { 

  .main-content {
    padding: 10px;
  }
}
</style>
